module.exports = __webpack_public_path__ + "static/1-grammarly-8e3f7606265fb2c1571a5fabe3224c63.png";